import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apiMainUser } from "../../constant";

export const chatEntryExitThunk = createAsyncThunk(
  "chatEntryExit",

  async ({ oldRoomID, newRoomID }) => {

    try {
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      if (oldRoomID) {
        await axios.post(
          apiMainUser + "chat_entry_exit",
          {
            chat_room_id: oldRoomID,
            event: "exit",
          },
          { headers }
        );
      }

      if (newRoomID) {
        axios.post(
          apiMainUser + "chat_entry_exit",
          {
            chat_room_id: newRoomID,
            event: "entry",
          },
          { headers }
        );
      }

      console.log("Entered chat room:", newRoomID);
      console.log("Existed chat room:", oldRoomID);
    } catch (error) {
      console.error("Error entering chat room:", error);
    }
    
  }
);

const initialState = {
  selectedRoomIdHostSide: null,
  selectedRoomIdHostSideMessages: [],
  pusherInstance: null,
  channelInstance: null,
  rightSideContent: null,
  chatRoomUnreadCount: null,
};

const MessageHostSideSlice = createSlice({
  name: "MessageHostSide",
  initialState,

  reducers: {
    SET_SELECTED_ROOM_ID_HOST_SIDE: (state, action) => {
      const room_id = action.payload;

      state.selectedRoomIdHostSide = action.payload;

      state.chatRoomUnreadCount = {
        ...state.chatRoomUnreadCount,
        [room_id]: 0,
      };
    },

    SET_SELECTED_ROOM_ID_HOST_SIDE_MESSAGES: (state, action) => {
      state.selectedRoomIdHostSideMessages = action.payload;
    },

    ADD_MESSAGE: (state, action) => {
      const { roomId, message } = action.payload;
      // Only add the message if it belongs to the current room

      if (state.selectedRoomIdHostSide === roomId) {
        state.selectedRoomIdHostSideMessages = [
          message,
          ...state.selectedRoomIdHostSideMessages,
        ];
      }
    },

    SET_PUSHER: (state, action) => {
      state.pusherInstance = action.payload;
    },

    SET_CHANNEL: (state, action) => {
      state.channelInstance = action.payload;
    },

    SET_RIGHT_SIDE_CONTENT: (state, action) => {
      state.rightSideContent = action.payload;
    },

    INITIALIZE_CHATROOM_UNREAD_COUNT: (state, action) => {
      state.chatRoomUnreadCount = action.payload;
    },

    INCREASE_UNREAD_COUNT_BY_ROOMID: (state, action) => {
      if (state.selectedRoomIdHostSide != action.payload) {
        const roomID = action.payload;

        state.chatRoomUnreadCount = {
          ...state.chatRoomUnreadCount,
          [roomID]: state.chatRoomUnreadCount[roomID] + 1,
        };
      }
      // state.chatRoomUnreadCount[roomID] = state.chatRoomUnreadCount[roomID] + 1;
    },
  },
});

export const {
  SET_SELECTED_ROOM_ID_HOST_SIDE,
  SET_SELECTED_ROOM_ID_HOST_SIDE_MESSAGES,
  SET_RIGHT_SIDE_CONTENT,
  ADD_MESSAGE,
  SET_PUSHER,
  SET_CHANNEL,
  INITIALIZE_CHATROOM_UNREAD_COUNT,
  INCREASE_UNREAD_COUNT_BY_ROOMID,
} = MessageHostSideSlice.actions;

export const MessageHostSideReducer = MessageHostSideSlice.reducer;
